var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-feed-section-content-footer"},[_c('span',[_vm._v("Vidroop.com © "+_vm._s(_vm.$moment().year()))])])}
var staticRenderFns = []

export { render, staticRenderFns }